// extracted by mini-css-extract-plugin
module.exports = {"card":"PlaceCard_card__Yeevd","name":"PlaceCard_name__3kywk","image":"PlaceCard_image__3Xb-3","desc":"PlaceCard_desc__3EEIC","address":"PlaceCard_address__3L227"};